import { useFormContext } from 'react-hook-form';
import styles from 'styles/pages/mypage/MypageInfoForm.module.scss';
import classNames from 'classnames';
import FormRadioBtn from 'components/common/forms/FormRadioBtn';
import {
  MypageInfoFormFields,
  RegistrationStatusType,
  TMypageInfoForm,
} from 'types/form/mypage';

type TProps = {
  disabled?: boolean;
};

const RegistrationStatus = ({ disabled }: TProps) => {
  const { formState } = useFormContext<TMypageInfoForm>();
  const registrationStatusError = formState.errors.registrationStatus;

  return (
    <>
      <p className={classNames(styles.label, 'opacity_50')}>
        재적 상태
        <span className="font_red fw700"> *</span>
      </p>
      <div className="mt24">
        <fieldset className={styles.radio_wrapper}>
          <FormRadioBtn
            name={MypageInfoFormFields.RegistrationStatus}
            value={RegistrationStatusType.재학}
            labelText={RegistrationStatusType.재학}
            labelStyle={{ opacity: 0.5 }}
            disabled={disabled}
          />
          <FormRadioBtn
            name={MypageInfoFormFields.RegistrationStatus}
            value={RegistrationStatusType.휴학}
            labelText={RegistrationStatusType.휴학}
            labelStyle={{ opacity: 0.5 }}
            disabled={disabled}
          />
        </fieldset>
        {!registrationStatusError && <div className={styles.div}></div>}
        {registrationStatusError && (
          <p className="error_text">{registrationStatusError?.message}</p>
        )}
      </div>
    </>
  );
};

export default RegistrationStatus;
